/**
 * NumberHandlingInfo — accordion explaining how phone numbers are processed.
 */

import React, { useState } from 'react';

export const NumberHandlingInfo: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 8, marginBottom: 16, background: 'var(--surface)' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '12px 16px', background: 'none', border: 'none', cursor: 'pointer',
          fontSize: 14, fontWeight: 600, color: 'var(--text-soft)',
        }}
      >
        <span>ℹ️ How are numbers handled?</span>
        <span>{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div style={{ padding: '0 16px 16px', fontSize: 13, color: 'var(--text-soft)', lineHeight: 1.7 }}>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            <li><strong>HQ / (M) suffixes</strong> — stripped before dialing. <code>1 212-345-6000 HQ</code> → dials <code>+12123456000</code></li>
            <li><strong>Extensions</strong> — removed. <code>1 305-418-4701 ext 1017</code> → dials the base number only</li>
            <li><strong>Two numbers in one cell</strong> — separated by <code>/</code> or a line break — each is dialed separately. Status is written as <code>VOICEMAIL; GOOD</code> (semicolon delimiter)</li>
            <li><strong>Duplicates</strong> — each unique number is dialed only once, even if it appears in multiple columns</li>
            <li><strong>International numbers</strong> — accepted (e.g., <code>91 96633 94963</code> for India, <code>52 55 4741 1485</code> for Mexico)</li>
            <li><strong>N/A, blank, or invalid cells</strong> — skipped automatically</li>
          </ul>
        </div>
      )}
    </div>
  );
};
